import { render, staticRenderFns } from "./FactoryCreatePool.vue?vue&type=template&id=2271b2e9&scoped=true&"
var script = {}
import style0 from "./FactoryCreatePool.vue?vue&type=style&index=0&id=2271b2e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2271b2e9",
  null
  
)

export default component.exports